var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bus-emty"},[_c('p',[_c('img',{attrs:{"alt":"","src":require("@/assets/nobus@3x.png")}}),_c('span',[_vm._v("暂无车辆信息")])])])}]

export { render, staticRenderFns }